"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateCustomerLoyaltyMutation = exports.useCreateCustomerLoyaltyMutation = exports.useGetCustomerLoyaltyQuery = exports.loyaltyApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
var loyaltyApi = (0, react_1.createApi)({
    reducerPath: "loyaltyApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.LETS_TRADE_USER_URL) !== null && _a !== void 0 ? _a : ""),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    tagTypes: ["Loyalty"],
    endpoints: function (builder) { return ({
        getCustomerLoyalty: builder.query({
            query: function (customerId) { return ({ url: "v2/get/loyalty", params: { customer_id: customerId } }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : null; },
            providesTags: function (_result, _error, customerId) { return [{ type: "Loyalty", id: customerId }]; },
        }),
        createCustomerLoyalty: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({ url: "user/loyalty_sign_up", method: "POST", body: body });
            },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var customerId = _a.customerId;
                return [{ type: "Loyalty", id: customerId }];
            },
        }),
        updateCustomerLoyalty: builder.mutation({
            query: function (_a) {
                var body = _a.body;
                return ({ url: "v2/update/loyalty", method: "PUT", body: body });
            },
            extraOptions: { token: base_query_1.userToken },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var customerId = _a.customerId;
                return [{ type: "Loyalty", id: customerId }];
            },
        }),
    }); },
});
exports.loyaltyApi = loyaltyApi;
var useGetCustomerLoyaltyQuery = loyaltyApi.useGetCustomerLoyaltyQuery, useCreateCustomerLoyaltyMutation = loyaltyApi.useCreateCustomerLoyaltyMutation, useUpdateCustomerLoyaltyMutation = loyaltyApi.useUpdateCustomerLoyaltyMutation;
exports.useGetCustomerLoyaltyQuery = useGetCustomerLoyaltyQuery;
exports.useCreateCustomerLoyaltyMutation = useCreateCustomerLoyaltyMutation;
exports.useUpdateCustomerLoyaltyMutation = useUpdateCustomerLoyaltyMutation;
